// extracted by mini-css-extract-plugin
module.exports = {"logo":"logo__cg3Ek","container":"container__1PUAE","inputs":"inputs__1VVKB","input":"input__1MMpo","results":"results__3nt1W","result":"result__JMIdA","saveBtn":"saveBtn__1I5IB"};